import api from '@api';
import {FormikHelpers} from 'formik';
import {notify} from '@gemcook/notification';
import {RouteComponentProps} from 'react-router-dom';

import constants from '@constants';
import paths from '@paths';

export const send = async (
  value: any,
  formikHelpers: FormikHelpers<any>,
  teamId: number,
  route: Pick<RouteComponentProps, 'history'>,
  userId: string
) => {
  try {
    await api.notifications.create({
      teamId,
      isManual: true,
      prefecture: value.prefecture,
      disasterType: value.disasterType,
      message: value.message.trim(),
      isEmailSending: value.isEmailSending,
      isSMSSending: value.isSMSSending,
      isConnectSending: value.isConnectSending,
      // 手動送信では震度を指定しないため、nullを渡す
      intensity: null,
      userId,
    });
    notify('災害通知を送信しました', 'success');
    route.history.push(paths.disasterNotices.main);
  } catch (error) {
    let errorMessage = '';
    if (error.response.data.message === 'destination could not found') {
      errorMessage = '対象の地域にユーザーが存在しません';
    } else {
      errorMessage = constants.ERRORS.UNKNWON;
    }

    notify(errorMessage, 'error');
  } finally {
    formikHelpers.setSubmitting(false);
  }
};
